/**
 * Utility for managing list styles CSS
 */

/**
 * Get CSS for proper nested list formatting in HTML/PDF output
 * @returns {string} CSS styles for nested lists
 */
export function getListStylesCSS() {
  return `<style>
ul { list-style-type: disc; }
ul ul { list-style-type: circle; }
ul ul ul { list-style-type: disc; }
ol { list-style-type: decimal; }
ol ol { list-style-type: lower-alpha; }
ol ol ol { list-style-type: lower-roman; }
ul, ol { line-height: normal; }
li > p { margin: 0; }
</style>`;
}

/**
 * Inject list styles CSS into HTML content if lists are present
 * @param {string} html - HTML content to process
 * @returns {string} HTML with injected styles if lists are found
 */
export function injectListStylesIfNeeded(html) {
  if (!html) return html;
  
  // Check if HTML contains lists and doesn't already have styles (case-insensitive)
  const htmlLower = html.toLowerCase();
  if ((htmlLower.includes('<ul>') || htmlLower.includes('<ol>')) && !htmlLower.includes('<style>')) {
    return getListStylesCSS() + html;
  }
  
  return html;
} 